// removed by extract-text-webpack-plugin
module.exports = {"hot-products-container":"hot-products-container","hot-products-title":"hot-products-title","hot-products":"hot-products","product":"product"};


//////////////////
// WEBPACK FOOTER
// ./components/home/sub-view/_HotProducts.scss
// module id = ./components/home/sub-view/_HotProducts.scss
// module chunks = 0